/**
 * 原生错误类型定义
 */
export interface NativeError {
  /** 错误码 */
  code: number
  /** 错误消息 */
  message: string
}

/**
 * 回调函数类型
 */
type CallbackFunction<T = unknown> = (error: NativeError | null, result: T | null) => void

export default class CallbackManager {
  private callbacks = new Map<string, CallbackFunction>()
  private counter = 0

  constructor() {
    this.init()
  }

  /**
   * 初始化回调管理器
   */
  init(): void {
    // 定期清理过期回调, 每30秒清理一次
    setInterval(() => {
      this.cleanup()
    }, 30000)
  }

  /**
   * 生成唯一回调ID
   */
  generateId(): string {
    this.counter++
    return `callback_${String(Date.now())}_${String(this.counter)}`
  }

  /**
   * 注册回调函数
   */
  register<T = unknown>(callback: CallbackFunction<T>): string {
    const id = this.generateId()
    this.callbacks.set(id, callback as CallbackFunction)
    return id
  }

  /**
   * 调用回调函数
   */
  invoke(id: string, error: NativeError | null, result: unknown): void {
    const callback = this.callbacks.get(id)
    if (callback) {
      callback(error, result)
      this.callbacks.delete(id) // 调用后删除回调
    }
  }

  /**
   * 清理过期回调
   */
  cleanup(): void {
    const now = Date.now()
    this.callbacks.forEach((_, id) => {
      const timestamp = parseInt(id.split('_')[1], 10)
      if (now - timestamp > 60000) {
        // 清理超过60秒的回调
        this.callbacks.delete(id)
      }
    })
  }
}
